export const selectedPractice = state => {
  return state.SelectedClientPractice;
}
export const clientPracticeDetails = state => {
  return state.ClientPractice;
}
export const debug = state => {
  return state.Debug;
}

export const navigationLinks = state => {
  return state.WidgetLinks;
}
export const selectedPet = state => {
  return state.SelectedPet;
}
export const species = state => {
  return state.Species;
}
export const sexes = state => {
  return state.Sexes;
}
export const newPetForm = state => {
  return state.NewPetForm;
}
export const pageNumber = state => {
  return state.PageNumber;
}
export const pets = state => {
  return state.Pets;
}
export const isLoading = state => {
  return state.IsLoading;
}
export const requestedServices = state => {
  return state.RequestedServices;
}
export const dueServices = state => {
  return state.DueServices;
}
export const showCalendarLoading = state => {
  return state.IsCalendarLoading;
}
export const appointmentWeekSlots = state => {
  return state.AppointmentSlots;
}
export const selectedAppointmentDay = state => {
  return state.SelectedAppointmentDay;
}
export const selectedAppointmentDateTime = state => {
  return state.SelectedAppointmentDateTime;
}

export const clientPractices = state =>{
  return state.ClientPractices
}

export const pageHeader = state => {
  switch (state.PageNumber) {
    case 1:
      return "Select a location";
    case 2:
      return "Customer Information";
    case 3:
      return "Pet Information";
    case 4:
      return "Appointment Services";
    case 5:
      return "Date and Time";
    case 6:
      return "Summary";
    default:
      return null;
  }
}
export const states = state => {
  return state.States;
}
export const petOwnerDetails = state => {
  return state.PetOwnerDetails;
}

export const checkIfCalendarValidState = state => {
  return state.RequestedServices.length > 0;
}

export const visitComments = state => {
  return state.VisitComments;
}

export const isAtLeastOneDueServiceIsSelected = state => {
  if (state.RequestedServices.length > 0 && state.RequestedServices.filter(e => e.Selected).length > 0) {
    return true;
  }

  return false;
}

export const isSickAppointment = state => {
  if (state.RequestedServices.filter(e => e.Selected && e.AppointmentType &&
      e.AppointmentType == "Sickness").length > 0) {
    return true;
  }

  return false;
}

export const formattedDateOfBirth = state => {
  return state.NewPetForm.FormattedDateOfBirth;
}

export const dateOfBirth = state => {
  return state.NewPetForm.DateOfBirth;
}

export const noImage = state => {
  return state.NoImage;
}



// WEBPACK FOOTER //
// ./src/store/getters.js